import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const createSelectors = (parentReducer) => {
    return new (class {
        selectReportTypes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.reportTypes;
        };
        selectVehicleAlerts = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.vehicleAlerts;
        };
        selectHsqeTemplates = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.template;
        };
        selectSpecificTemplates = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.specificTemplate;
        };
        selectAllReports = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.reports;
        };
        selectJobPackReports = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];

            return reducer.jobPackReports;
        };
        selectReportKeys = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.reportKeys;
        };
        selectMonth = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.month;
        };
        selectToMonth = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.toMonth;
        };
        selectYear = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.year;
        };
        selectReportType = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.reportType;
        };
        getDownloads = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildExcelDocWidget_reducer"];
            return reducer.downloads;
        };

        selectDocuments = createSelector([this.getDownloads], (downloads) => {
            if (
                downloads === false ||
                typeof downloads === "undefined" ||
                downloads === null
            ) {
                return [];
            }
        
            let regDownloads = Object.keys(downloads).map((e) => {
                return downloads[e];
            });
            return regDownloads;
        });

        selectReportsForExcel = createSelector(
            [
                this.selectReportType,
                this.selectAllReports,
                this.selectMonth,
                this.selectToMonth,
                this.selectYear,
                this.selectJobPackReports,
                this.selectSpecificTemplates,
                this.selectVehicleAlerts,
            ],
            (
                reportType = false,
                allReports = false,
                month = moment().format("MMM").toLowerCase(),
                toMonth = moment().format("MMM").toLowerCase(),
                year = moment().format("YYYY"),
                allJobPackReports = false,
                filterTemplate = false,
                vehicleAlerts = false
            ) => {
                if (
                    reportType &&
                    reportType !== "all_categories" &&
                    (allReports || allJobPackReports) &&
                    reportType !== "vehicle_alerts"
                ) {
                    let reports, jobPackReports;
                    if (allReports)
                        reports = getReports(
                            allReports,
                            reportType,
                            month,
                            toMonth,
                            year
                        );

                    if (allJobPackReports)
                        jobPackReports = getJPReports(
                            allJobPackReports,
                            reportType,
                            month,
                            toMonth,
                            year
                        );
                    if (
                        Object.keys(reports).length === 0 &&
                        Object.keys(jobPackReports).length === 0
                    )
                        return false;

                    if (reports && jobPackReports) {
                        if (reportType === "custom_report") {
                            var finalArray = {};
                            Object.values(reports).map((report) => {
                                if (report.config === filterTemplate) {
                                    finalArray = _.assign(finalArray, {
                                        [report.timestamp]: report,
                                    });
                                    return null;
                                } else {
                                    return null;
                                }
                            });
                            return [finalArray];
                        } else {
                            return [reports, jobPackReports];
                        }
                    } else if (reports && !jobPackReports) {
                        return [reports];
                    } else if (!reports && jobPackReports) {
                        return [jobPackReports];
                    } else return false;
                } else if (reportType === "vehicle_alerts") {
                    let alerts, al;
                    if (vehicleAlerts) var type = "vehicle_checklist";
                    alerts = getVehcileReports(allReports, type);
                    let obj1 = {};
                    alerts.map((e) => {
                        Object.keys(e).map((f) => {
                            Object.keys(vehicleAlerts).map((alertKey) => {
                                if (f === alertKey) {
                                    let obj = {};
                                    obj[f] = e[f];
                                    obj1 = { ...obj1, ...obj };
                                    return obj;
                                } else return null;
                            });
                            return null;
                        });
                        return null;
                    });
                    al = filterByDate([obj1], month, year);
                    if (al) {
                        var finalObject = {};
                        Object.values(al).map((alert => {
                            finalObject=_.assign(finalObject, {
                                [alert.timestamp]: alert,
                            });
                            return null;
                        }))
                        return [finalObject];
                    }
                } else return false;
            }
        );
    })();
};

//have to update To Date in this loop - Rakesh GN
const getJPReports = (allJPReports, reportType, month, toMonth, year) => {

    let reps = {};
    _.compact(
        Object.keys(allJPReports).map((e) => {
            let jps = _.get(allJPReports[e], `${year}.${month}`) || null;
            if (jps)
                _.compact(
                    Object.keys(jps).map((id) => {
                        let reports =
                            _.get(jps[id], `reports.${reportType}`) || null;
                        if (reports) reps = _.assign(reps, { ...reports });
                        return null;
                    })
                );
            return null;
        })
    );
    return reps !== {} ? reps : null;
};
const getVehcileReports = (allReports, type) => {
    allReports = _.compact(
        Object.keys(allReports).map((e) => {
            return _.get(allReports[e], `reports.${type}`) || null;
        })
    );
    return allReports;
};
const getReports = (allReports, reportType, month, toMonth, year) => {

    allReports = _.compact(
        Object.keys(allReports).map((e) => {
            return _.get(allReports[e], `reports.${reportType}`) || null;
        })
    );
    return filterByDate(allReports, month, toMonth, year);
};

const filterByDate = (reports, month, toMonth, year) => {
    let object = {};
    let months =  {
        jan: 1,
        feb: 2,
        mar: 3,
        apr: 4,
        may: 5,
        jun: 6,
        jul: 7,
        aug: 8,
        sep: 9,
        oct: 10,
        nov: 11,
        dec: 12,
    }
    var toMonthValue = months[toMonth];
    var fromMonthValue = months[month];
    reports &&
        reports.map((e) => {
            Object.keys(e).map((f) => {
                let date = f.split(" ")[0];
                // let curMonth = moment(date, "DD-MM-YYYY")
                //     .format("MMM")
                //     .toLowerCase();
                
                // let curYear = moment(date, "DD-MM-YYYY").format("YYYY");
                // if (month === curMonth && Number(year) === Number(curYear))
                //     object = _.assign(object, { [f]: e[f] });
                // return null;
                var d =  moment(date, "DD-MM-YYYY");
                let curmonth = d.format('M');
                if(isNaN(curmonth)){
                    curmonth = 0;
                }
                let curYear = moment(date, "DD-MM-YYYY").format("YYYY");
                if(Number(year) === Number(curYear) && fromMonthValue <= curmonth && toMonthValue >= curmonth  && curmonth !== 0)
                    object = _.assign(object, { [f]: e[f] });
                return null;
                
            });
            return null;
        });
    return object;
};
export default createSelectors;
